export { default } from './ButtonConfirmPopUp';



// WEBPACK FOOTER //
// ./src/components/Common/Buttons/ButtonConfirmPopUp/index.js